import React from 'react'
import ReactDOM from 'react-dom/client'
import * as Sentry from "@sentry/react";
import {BrowserTracing} from "@sentry/tracing";
import Widget from './Widget'
import './css/widget.min.css'
import {widgetId} from './utils'
import { dataset_defaults } from './dataset_defaults';

let styleEndpoint = document.querySelector(widgetId)?.dataset.style_endpoint ?? dataset_defaults.style_endpoint
if (!styleEndpoint) console.warn(`To use widget in shadowDom, please add a data-style_endpoint attribute to the element with ID: '${widgetId}'`)
const dataBlobUrl = document.querySelector(widgetId).getAttribute('data-blob_url')
const dataMonitoringFileName = document.querySelector(widgetId).getAttribute('data-monitoring_file_name')

const monitoringConfigUrl = `${dataBlobUrl}/${dataMonitoringFileName}`;

const successCb = (response) => {
    try {
        Sentry.init({
        dsn: response.sentry_dsn,
        integrations: [new BrowserTracing()],
        debug: response.sentry_debug,
        sampleRate: response.sentry_sample_rate,
        maxBreadcrumbs: 50,
        environment: response.sentry_environment,

        // We recommend adjusting this value in production, or using tracesSampler
        // for finer control
        tracesSampleRate: 0.75,
        });
        Sentry.setTag("identifier", response.sentry_identifier_tag);
        console.log(response)
    } catch(error) {
        console.error(error)
    }
};

const errorCb = (err) => {
    console.error('Error downloading monitoring config', err);
};

function downloadMonitoringConfig(monitoringConfigUrl, successCb, errorCb) {
    fetch(monitoringConfigUrl)
      .then(response => response.json())
      .then(successCb)
      .catch(errorCb);
}

if (dataBlobUrl) {downloadMonitoringConfig(monitoringConfigUrl, successCb, errorCb)}


if (styleEndpoint) {
    // get our shadowDom host container
    const host = document.querySelector(widgetId)
    // attach a shadowDom to the host container
    host.attachShadow({ mode: 'open' })
    // Get the shadowRoot container
    const root = ReactDOM.createRoot(document.querySelector(widgetId).shadowRoot)
    // Render the react application within the shadowDom container

    root.render(
        <React.StrictMode>
            <Widget styleEndpoint={styleEndpoint}/>
            {/* <SettingsGUIWrapper/> // this is for testing only*/}
        </React.StrictMode>
    )
} else {
    const root = ReactDOM.createRoot(document.querySelector(widgetId))
    root.render(
        <React.StrictMode>
            <Widget/>
            {/* <SettingsGUIWrapper/> // this is for testing only*/}
        </React.StrictMode>
    )
}
